import { uuidv4 } from "./uuidv4";

export const getUniqueId = uuidv4;
